import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Col, Container, Row } from "reactstrap";
import { getRecommendedData } from "../store/actions/MenuActions";

const RecommendedItems = ({ data }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { darkMode } = useSelector((state) => state.global);
  const [updatedData, setUpdatedData] = useState([]);

  useEffect(() => {
    if (data?.length > 0) {
      const newData = [...data];

      data.forEach((item, index) => {
        dispatch(
          getRecommendedData(item.id, (recommendedItem) => {
            newData[index] = {
              ...newData[index],
              image: recommendedItem?.images?.[0] || item.image,
            };
            setUpdatedData([...newData]);
          })
        );
      });
    }
  }, [dispatch, data]);

  return (
    <Container className="most_popular">
      <Row className="mt-3 d-flex justify-content-center align-items-center">
        <h4
          className={
            darkMode
              ? "fs--18 fw--600 mb-0 normal-heading-dark"
              : "fs--18 fw--600 mb-0 normal-heading"
          }
        >
          {updatedData?.length > 0
            ? "Recommended Products"
            : "No Recommended Products"}
        </h4>
      </Row>
      <Row className="py-3 justify-content-center recommended_items align-items-center cursor-pointer gx-3 gy-3">
        {updatedData?.map((item) => (
          <Col md={6} lg={6} xl={6} sm={12} xs={12} key={item?.id}>
            <div
              className="d-flex flex-row recommended_card p-2"
              style={{
                background: darkMode ? "#3d3d3d" : "#ffffff",
              }}
              onClick={() => history.push(`/productDetails/${item?.id}`)}
            >
              <img
                className="mr-3 recommended_card__img"
                src={item?.image}
                alt="product"
                style={{
                  height: "60px",
                  width: "60px",
                  objectFit: "cover",
                }}
              />
              <div className="d-flex flex-column recommended_card__body justify-content-center align-items-center">
                <p
                  className={
                    darkMode ? "title-dark text-center" : "title text-center"
                  }
                >
                  {item?.value}
                </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default RecommendedItems;
